import axios from '../utils/axios';
import Constants from './types';
import { getSessionId, getPayloadFromError } from '../utils';

export const getAdaptiveMatchingConfiguration = (entityId, theSessionId) => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    dispatch({
      type: Constants.ADAPTIVE_MATCHING_GET_CONFIGURATIONS_REQUEST
    });
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/adaptive-matching/configuration',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      }
    })
      .then(response => {
        dispatch({
          type: Constants.ADAPTIVE_MATCHING_GET_CONFIGURATIONS_SUCCESS,
          payload: response.data
        });
      })
      .catch(err => {
        const payload = getPayloadFromError(err);
        dispatch({
          type: Constants.ADAPTIVE_MATCHING_GET_CONFIGURATIONS_FAILURE,
          payload
        });
      });
  };
};

export const createAdaptiveMatchingConfiguration = (entityId, theSessionId) => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    dispatch({ type: Constants.ADAPTIVE_MATCHING_SAVE_CONFIGURATION_REQUEST });

    axios({
      method: 'POST',
      url: '/openempi-ws-rest/1.0/adaptive-matching/configuration',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      }
    })
      .then(response => {
        dispatch({
          type: Constants.ADAPTIVE_MATCHING_SAVE_CONFIGURATION_SUCCESS,
          payload: response.data
        });
      })
      .catch(err => {
        const payload = getPayloadFromError(err);
        dispatch({
          type: Constants.ADAPTIVE_MATCHING_SAVE_CONFIGURATION_FAILURE,
          payload
        });
      });
  };
};

export const saveAdaptiveMatchingConfiguration = (
  entityId,
  config,
  theSessionId
) => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    dispatch({ type: Constants.ADAPTIVE_MATCHING_SAVE_CONFIGURATION_REQUEST });

    axios({
      method: 'PUT',
      url: `/openempi-ws-rest/1.0/adaptive-matching/configuration/${entityId}`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      },
      data: config
    })
      .then(response => {
        dispatch({
          type: Constants.ADAPTIVE_MATCHING_SAVE_CONFIGURATION_SUCCESS,
          payload: response.data
        });
      })
      .catch(err => {
        const payload = getPayloadFromError(err);
        dispatch({
          type: Constants.ADAPTIVE_MATCHING_SAVE_CONFIGURATION_FAILURE,
          payload
        });
      });
  };
};

export const deleteAdaptiveMatchingConfiguration = (entityId, theSessionId) => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    dispatch({
      type: Constants.ADAPTIVE_MATCHING_DELETE_CONFIGURATION_REQUEST
    });

    axios({
      method: 'delete',
      url: `/openempi-ws-rest/1.0/adaptive-matching/configuration/${entityId}`,
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(() => {
        dispatch({
          type: Constants.ADAPTIVE_MATCHING_DELETE_CONFIGURATION_SUCCESS,
          payload: entityId
        });
      })
      .catch(err => {
        const payload = getPayloadFromError(err);
        dispatch({
          type: Constants.ADAPTIVE_MATCHING_DELETE_CONFIGURATION_FAILURE,
          payload
        });
      });
  };
};

export const regenerateAdaptiveMatchingConfiguration = (
  entityId,
  theSessionId
) => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    dispatch({
      type: Constants.ADAPTIVE_MATCHING_REGENERATE_CONFIGURATION_REQUEST
    });

    axios({
      method: 'post',
      url: `/openempi-ws-rest/1.0/adaptive-matching/configuration/${entityId}/regenerate`,
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(response => {
        dispatch({
          type: Constants.ADAPTIVE_MATCHING_REGENERATE_CONFIGURATION_SUCCESS,
          payload: response.data
        });
      })
      .catch(err => {
        const payload = getPayloadFromError(err);
        dispatch({
          type: Constants.ADAPTIVE_MATCHING_REGENERATE_CONFIGURATION_FAILURE,
          payload
        });
      });
  };
};
